;
export const COLORS = ['#ffffb3', '#ffcc99', '#ffddff', '#b3daff', '#ccffcc'];
export const DEFAULT_ENTRIES = [
    {
        id: 0,
        lane: "Samsboard",
        title: "Click me to change color",
        color: COLORS[0],
    },
    {
        id: 1,
        lane: "Samsboard",
        title: "Right click me to edit",
        color: COLORS[0],
    },
    {
        id: 2,
        lane: "Samsboard",
        title: "Delete my text and I will disappear",
        color: COLORS[0],
    },
    {
        id: 3,
        lane: "Samsboard",
        title: "You can drag me around!",
        color: COLORS[2],
    },
    {
        id: 4,
        lane: "X Project",
        title: "Click the button on the top right to add lanes",
        color: COLORS[4],
    },
    {
        id: 5,
        lane: "X Project",
        title: "Login to save your board!",
        color: COLORS[1],
    },
];
